// extracted by mini-css-extract-plugin
export default {"container":"error_container__9r+Yh","link":"error_link__o1vYB"};